<template>
  <CustomModal :is-modal="showFeedback"
               :closeOuth="false"
               title=""
               width="lg"
               @closeModal="showFeedback = false"
  >
    <div class="row">
      <div class="col-sm-12 text-center" v-if="step === 1">
        <div class="">1 / 3</div>
        <div class="mb-3">
          <h3>{{ questions[0].title }}</h3>
        </div>
        <div class="d-flex justify-content-center">
          <star-rating
              v-model="questions[0].rating"
              @rating-selected="setRating"
              :show-rating="false"
              :star-size="42"
          />
        </div>
        <div class="mt-5" v-if="questions[0].rating < 5 && questions[0].rating > 0">
          <h3>{{ suggestions[0].title }}</h3>
          <textarea  cols="30" v-model="questions[0].answer" rows="3" class="form-control"></textarea>
        </div>
        <div class="mt-4">
          <base-button type="success" :disabled="validMessage" @click="nextStep(2)">Continuar</base-button>
          <p><small>Esta pregunta es obligatoria</small></p>
        </div>
      </div>
      <div class="col-sm-12 text-center" v-else-if="step === 2">
        <div class="">2 / 3</div>
        <div class="mb-3">
          <h3>{{ questions[1].title }}</h3>
        </div>
        <div class="d-flex justify-content-center">
          <star-rating
              v-model="questions[1].rating"
              @rating-selected="setRating"
              :show-rating="false"
              :star-size="42"
          />
        </div>
        <div class="mt-5" v-if="questions[1].rating < 5 && questions[1].rating > 0">
          <h3>{{ suggestions[1].title }}</h3>
          <textarea  cols="30" v-model="questions[1].answer" rows="3" class="form-control"></textarea>
        </div>
        <div class="mt-4">
          <base-button type="success" :disabled="validMessage" @click="nextStep(3)">Continuar</base-button>
          <p><small>Esta pregunta es obligatoria</small></p>
        </div>
      </div>
      <div class="col-sm-12 text-center" v-else>
        <div class="">3 / 3</div>
        <div class="mb-3">
          <h3>{{ questions[2].title }}</h3>
        </div>
        <div class="d-flex justify-content-center">
          <star-rating
              v-model="questions[2].rating"
              @rating-selected="setRating"
              :show-rating="false"
              :star-size="42"
          />
        </div>
        <div class="mt-5" v-if="questions[2].rating < 5 && questions[2].rating > 0">
          <h3>{{ suggestions[2].title }}</h3>
          <textarea  cols="30" v-model="questions[2].answer" rows="3" class="form-control"></textarea>
        </div>
        <div class="mt-4" v-if="!btnSendDisabled">
          <base-button type="success" :disabled="validMessage" @click="sendFeedback">Enviar</base-button>
          <p><small>Esta pregunta es obligatoria</small></p>
        </div>
      </div>
    </div>
  </CustomModal>
</template>

<script>
import StarRating from 'vue-star-rating'
import CustomModal from "../CustomModal";
import axios from "axios";
import moment from "moment";
export default {
  components: {
    CustomModal,
    StarRating,
  },
  name: "ModalFeedback",
  data() {
    return {
      rating: 0,
      showFeedback: false,
      step: 1,
      questions: [
        {
          id: 1,
          title: '¿Cómo calificas nuestro soporte y tiempos de respuesta?.*',
          answer: '',
          rating: 0
        },
        {
          id: 2,
          title: '¿Cómo calificas la labor  del supervisor asignado en catering durante la operación diario?.*',
          answer: '',
          rating: 0
        },
        {
          id: 3,
          title: '¿Cómo califica nuestra plataforma?, Tomando en cuenta: Formato de precantidades, Lista de insumos, recetas, cantidades y consolidados.*',
          answer: '',
          rating: 0
        }
      ],
      suggestions: [
        {
          id: 1,
          title: '¿Qué es lo que no te gustó?'
        },
        {
          id: 2,
          title: '¿Qué podemos mejorar?'
        },
        {
          id: 3,
          title: '¿Qué podemos mejorar?'
        }
      ],
      start_week : moment().startOf('week').format("YYYY-MM-DD"),
      end_week: moment().endOf('week').format("YYYY-MM-DD"),
      btnSendDisabled: false
    }
  },
  computed: {
    validMessage() {
      if(this.step === 1) {
        return [1,2,3,4].includes(this.questions[0].rating) ? this.questions[0].answer.trim().length <= 15 : this.questions[0].rating === 0
      }else if(this.step === 2) {
        return [1,2,3,4].includes(this.questions[1].rating) ? this.questions[1].answer.trim().length <= 15 : this.questions[1].rating === 0
      }else {
        return [1,2,3,4].includes(this.questions[2].rating) ? this.questions[2].answer.trim().length <= 15 : this.questions[2].rating === 0
      }
    }
  },
  created() {
    this.checkFeedbackWeek()
  },
  methods: {
    setRating(rate) {
      if(this.step === 1) {
        this.questions[0].rating = rate;
      }else if (this.step === 2) {
        this.questions[1].rating = rate;
      }else {
        this.questions[2].rating = rate;
      }
    },
    nextStep(step) {
      this.step = step;
    },
    async sendFeedback() {
      try{
        this.btnSendDisabled = true
        await axios.post('/feedback/catering',{
          questions: this.questions,
          start_week : this.start_week,
          end_week: this.end_week
        })
        this.showFeedback = false;
      }catch (e) {

      }
    },
    async checkFeedbackWeek() {
      try{
        let start_week  =  moment().startOf('week').format("YYYY-MM-DD")
        let end_week =  moment().endOf('week').format("YYYY-MM-DD")
        const response = await axios.get('check/feedback/week',{
          params: {
            start_week,
            end_week
          }
        })
        let currentHour = moment().hour()
        let isThursday = moment().day() === 4
        if(isThursday) {
          if(currentHour >=14) {
            this.showFeedback = !response.data.check
          }
        }else{
          if(moment().day() > 4){
            this.showFeedback = !response.data.check
          }
        }
        // this.showFeedback = !response.data.check && isThursday
      }catch (e){

      }
    }
  }
}
</script>

<style scoped>

</style>